import * as React from 'react'
import { IAudioControls } from './hooks/use_audio_controls'

interface IProps {
  id: number
  src: string
  controls: IAudioControls
}

const AudioPlayer: React.FC<IProps> = ({ id, src, controls }) => {
  return (
    <audio ref={controls.ref} data-id={id}>
      <source src={src} />
    </audio>
  )
}

export { AudioPlayer }
